<template>
  <div class="event-form">
    <div class="form-container">
      <div class="form-header-card">
        <div class="header-decoration"></div>
        <div class="header-content">
          <h1 class="form-title">
            Боловсролын салбарын шилдэг арга xэмжээнүүдэд оролцоx санал xүсэлт
          </h1>
          <p class="form-subtitle">
            Энэ бол урдчилсан судалгаа, бид таньтай цаг xугацаанд xолбогдож
            мэдээлэл өгнө.
          </p>
        </div>
      </div>

      <form @submit.prevent="submitForm">
        <!-- Овог нэр -->
        <div class="form-card">
          <div class="field-content">
            <label class="form-label">Овог нэр</label>
            <input
              v-model="formData.fullName"
              type="text"
              class="form-input"
              placeholder="Таны нэрийг оруулна уу"
            />
          </div>
        </div>

        <!-- Байгууллагын нэр -->
        <div class="form-card">
          <div class="field-content">
            <label class="form-label">Байгууллагын нэр</label>
            <input
              v-model="formData.organization"
              type="text"
              class="form-input"
              placeholder="Байгууллагын нэрийг оруулна уу"
            />
          </div>
        </div>

        <!-- Та аль арга хэмжээнд оролцохыг хүсч байна вэ? -->
        <div class="form-card">
          <div class="field-content">
            <label class="form-label"
              >Та аль арга хэмжээнд оролцохыг хүсч байна вэ?</label
            >
            <p class="field-description" v-if="loadingEvents">
              Арга хэмжээ ачаалж байна...
            </p>
            <p class="field-description" v-else-if="events.length === 0">
              Одоогоор арга хэмжээ байхгүй байна
            </p>
            <div class="checkbox-list" v-else>
              <label
                class="checkbox-item"
                v-for="event in events"
                :key="event.id"
              >
                <input
                  type="checkbox"
                  v-model="formData.selectedEvents"
                  :value="event.id"
                />
                <span class="checkbox-label">
                  <span class="checkbox-box"></span>
                  <span class="checkbox-text">
                    <strong>{{ event.name }}</strong>
                    <br />
                    <small style="opacity: 0.8"
                      >{{ event.date }} | {{ event.location }}</small
                    >
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>

        <!-- Та арга хэмжээнд оролцвол ямар чиглэл, бүтээгдэхүүн сонирхолж байгаа вэ? -->
        <div class="form-card">
          <div class="field-content">
            <label class="form-label"
              >Та арга хэмжээнд оролцвол ямар чиглэл, бүтээгдэхүүн сонирхолж
              байгаа вэ?</label
            >
            <div class="checkbox-list">
              <label class="checkbox-item">
                <input
                  type="checkbox"
                  v-model="formData.interests"
                  value="Ангийн самбар"
                />
                <span class="checkbox-label">
                  <span class="checkbox-box"></span>
                  <span class="checkbox-text">Ангийн самбар</span>
                </span>
              </label>
              <label class="checkbox-item">
                <input
                  type="checkbox"
                  v-model="formData.interests"
                  value="Таблэт"
                />
                <span class="checkbox-label">
                  <span class="checkbox-box"></span>
                  <span class="checkbox-text">Таблэт</span>
                </span>
              </label>
              <label class="checkbox-item">
                <input
                  type="checkbox"
                  v-model="formData.interests"
                  value="Биеийн тамир"
                />
                <span class="checkbox-label">
                  <span class="checkbox-box"></span>
                  <span class="checkbox-text">Биеийн тамир</span>
                </span>
              </label>
              <label class="checkbox-item">
                <input
                  type="checkbox"
                  v-model="formData.interests"
                  value="Лаборатори"
                />
                <span class="checkbox-label">
                  <span class="checkbox-box"></span>
                  <span class="checkbox-text">Лаборатори</span>
                </span>
              </label>
              <label class="checkbox-item">
                <input
                  type="checkbox"
                  v-model="formData.interests"
                  value="Ухаалаг самбар (smartboard)"
                />
                <span class="checkbox-label">
                  <span class="checkbox-box"></span>
                  <span class="checkbox-text">Ухаалаг самбар (smartboard)</span>
                </span>
              </label>
              <label class="checkbox-item">
                <input
                  type="checkbox"
                  v-model="formData.interests"
                  value="Бусад"
                />
                <span class="checkbox-label">
                  <span class="checkbox-box"></span>
                  <span class="checkbox-text">Бусад</span>
                </span>
              </label>
            </div>
          </div>
        </div>

        <!-- Холбоо барих утас -->
        <div class="form-card">
          <div class="field-content">
            <label class="form-label">Холбоо барих утас</label>
            <input
              v-model="formData.phone"
              type="tel"
              class="form-input"
              placeholder="+976 9999 9999"
            />
          </div>
        </div>

        <!-- Холбоо барих имэйл -->
        <div class="form-card">
          <div class="field-content">
            <label class="form-label">Холбоо барих имэйл</label>
            <input
              v-model="formData.email"
              type="email"
              class="form-input"
              placeholder="example@email.com"
            />
          </div>
        </div>

        <!-- Таны албан тушаал -->
        <div class="form-card">
          <div class="field-content">
            <label class="form-label">Таны албан тушаал</label>
            <div class="radio-list">
              <label class="radio-item">
                <input
                  type="radio"
                  v-model="formData.position"
                  value="Захирал"
                />
                <span class="radio-label">
                  <span class="radio-circle"></span>
                  <span class="radio-text">Захирал</span>
                </span>
              </label>
              <label class="radio-item">
                <input
                  type="radio"
                  v-model="formData.position"
                  value="Сургалтын менежер"
                />
                <span class="radio-label">
                  <span class="radio-circle"></span>
                  <span class="radio-text">Сургалтын менежер</span>
                </span>
              </label>
              <label class="radio-item">
                <input type="radio" v-model="formData.position" value="Багш" />
                <span class="radio-label">
                  <span class="radio-circle"></span>
                  <span class="radio-text">Багш</span>
                </span>
              </label>
              <label class="radio-item">
                <input type="radio" v-model="formData.position" value="Бусад" />
                <span class="radio-label">
                  <span class="radio-circle"></span>
                  <span class="radio-text">Бусад</span>
                </span>
              </label>
            </div>
          </div>
        </div>

        <!-- Танд дарааx улсын виз байгаа юу? -->
        <div class="form-card">
          <div class="field-content">
            <label class="form-label">Танд дарааx улсын виз байгаа юу?</label>
            <p class="field-description">
              Энэ мэдээллээр виза бүрдүүлэлтийг бид хийх эсэхийг мэднэ
            </p>
            <div class="checkbox-list">
              <label class="checkbox-item">
                <input
                  type="checkbox"
                  v-model="formData.visas"
                  value="Солонгос"
                />
                <span class="checkbox-label">
                  <span class="checkbox-box"></span>
                  <span class="checkbox-text">Солонгос</span>
                </span>
              </label>
              <label class="checkbox-item">
                <input
                  type="checkbox"
                  v-model="formData.visas"
                  value="Америк"
                />
                <span class="checkbox-label">
                  <span class="checkbox-box"></span>
                  <span class="checkbox-text">Америк</span>
                </span>
              </label>
              <label class="checkbox-item">
                <input
                  type="checkbox"
                  v-model="formData.visas"
                  value="Шингени"
                />
                <span class="checkbox-label">
                  <span class="checkbox-box"></span>
                  <span class="checkbox-text">Шингени</span>
                </span>
              </label>
            </div>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="form-actions-card">
          <button type="submit" class="submit-btn" :disabled="submitting">
            <span v-if="submitting" class="btn-content">
              <span class="spinner"></span>
              <span>Илгээж байна...</span>
            </span>
            <span v-else class="btn-content">
              <span>Илгээх</span>
            </span>
          </button>
          <button type="button" class="clear-btn" @click="resetForm">
            <span>Цэвэрлэх</span>
          </button>
        </div>
      </form>

      <!-- Success Message -->
      <div v-if="submitted" class="success-overlay">
        <div class="success-card">
          <div class="success-icon-wrapper">
            <div class="success-icon">✓</div>
          </div>
          <h2 class="success-title">Амжилттай илгээгдлээ!</h2>
          <p class="success-subtitle">Таны бүртгэлийг хүлээн авлаа</p>
          <div class="success-details">
            <div class="detail-item">
              <span class="detail-icon">📧</span>
              <span class="detail-text">Баталгаажуулах имэйлийг илгээлээ</span>
            </div>
            <div class="detail-item">
              <span class="detail-icon">📅</span>
              <span class="detail-text"
                >Арга хэмжээний мэдээллийг удахгүй илгээх болно</span
              >
            </div>
            <div class="detail-item">
              <span class="detail-icon">🎟️</span>
              <span class="detail-text"
                >Тасалбарын мэдээлэл дараа илгээгдэнэ</span
              >
            </div>
          </div>
          <p class="success-note">
            Бид тантай удахгүй холбогдох болно. Баярлалаа!
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../firebase";
import {
  collection,
  setDoc,
  doc,
  serverTimestamp,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";

export default {
  name: "FormFillPage",
  data() {
    return {
      submitted: false,
      submitting: false,
      loadingEvents: false,
      events: [],
      formData: {
        fullName: "",
        organization: "",
        selectedEvents: [],
        months: [],
        interests: [],
        phone: "",
        email: "",
        position: "",
        visas: [],
      },
    };
  },
  mounted() {
    this.fetchEvents();
  },
  methods: {
    getMonthName(monthNumber) {
      const months = [
        "1-р сар (Январь)",
        "2-р сар (Февраль)",
        "3-р сар (Март)",
        "4-р сар (Апрель)",
        "5-р сар (Май)",
        "6-р сар (Июнь)",
        "7-р сар (Июль)",
        "8-р сар (Август)",
        "9-р сар (Сентябрь)",
        "10-р сар (Октябрь)",
        "11-р сар (Ноябрь)",
        "12-р сар (Декабрь)",
      ];
      return months[monthNumber - 1];
    },
    async fetchEvents() {
      this.loadingEvents = true;
      try {
        const eventsQuery = query(
          collection(db, "events"),
          orderBy("order", "asc")
        );
        const querySnapshot = await getDocs(eventsQuery);
        this.events = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ref: doc.ref,
          ...doc.data(),
        }));
        console.log(this.events);
        console.log("Events loaded:", this.events.length);
      } catch (error) {
        console.error("Error fetching events:", error);
        this.events = [];
      } finally {
        this.loadingEvents = false;
      }
    },
    async submitForm() {
      if (!this.formData.email) {
        alert("Имэйл хаягаа оруулна уу.");
        return;
      }

      if (!this.formData.phone) {
        alert("Утасны дугаараа оруулна уу.");
        return;
      }

      this.submitting = true;

      try {
        // Get selected events details
        const selectedEventsData = this.formData.selectedEvents.map(
          (eventId) => {
            const event = this.events.find((e) => e.id === eventId);
            return {
              id: eventId,
              name: event?.name || "",
              date: event?.date || "",
              location: event?.location || "",
            };
          }
        );

        // Save to Firebase Firestore

        await setDoc(doc(db, "eventRegistrations", this.formData.email), {
          ...this.formData,
          eventsData: selectedEventsData,
          submittedAt: serverTimestamp(),
          createdAt: new Date().toISOString(),
        });

        // await addDoc(collection(db, "eventRegistrations"), {
        //   ...this.formData,
        //   eventsData: selectedEventsData,
        //   submittedAt: serverTimestamp(),
        //   createdAt: new Date().toISOString(),
        // });

        console.log("Form submitted successfully to Firebase");
        this.submitted = true;

        // Reset form after 3 seconds
        setTimeout(() => {
          this.submitted = false;
          this.resetForm();
        }, 3000);
      } catch (error) {
        console.error("Error submitting form:", error);
        alert("Алдаа гарлаа. Дахин оролдоно уу.");
      } finally {
        this.submitting = false;
      }
    },
    resetForm() {
      this.formData = {
        fullName: "",
        organization: "",
        selectedEvents: [],
        months: [],
        interests: [],
        phone: "",
        email: "",
        position: "",
        visas: [],
      };
    },
  },
};
</script>

<style scoped>
.event-form {
  min-height: 100vh;
  background: #f0ebf8;
  padding: 100px 12px 60px;
  position: relative;
}

.form-container {
  max-width: 900px;
  width: 66.67%;
  margin: 0 auto;
  padding: 0 15px;
  position: relative;
  z-index: 1;
}

.form-header-card {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(255, 255, 255, 0.9) 100%
  );
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 48px 40px;
  margin-bottom: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.3);
  position: relative;
  overflow: hidden;
}

.header-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
}

.header-content {
  text-align: center;
}

.form-title {
  font-size: 36px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 12px 0;
  line-height: 1.3;
  font-family: "Google Sans", Roboto, Arial, sans-serif;
}

.form-subtitle {
  font-size: 16px;
  color: #5f6368;
  margin: 0;
  line-height: 1.6;
}

.form-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 32px;
  margin-bottom: 20px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.field-content {
  flex: 1;
  width: 100%;
}

.form-label {
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: #202124;
  margin-bottom: 12px;
  line-height: 1.5;
}

.field-description {
  font-size: 13px;
  color: #5f6368;
  margin: -8px 0 16px 0;
  font-style: italic;
}

.form-input {
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  font-size: 15px;
  font-family: inherit;
  color: #202124;
  background: white;
  box-sizing: border-box;
}

.form-input::placeholder {
  color: #b0b0b0;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
}

.checkbox-list,
.radio-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.checkbox-item,
.radio-item {
  cursor: pointer;
  display: block;
}

.checkbox-item input[type="checkbox"],
.radio-item input[type="radio"] {
  display: none;
}

.checkbox-label,
.radio-label {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  background: #f8f9fa;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  font-size: 15px;
  color: #202124;
}

.checkbox-box,
.radio-circle {
  width: 24px;
  height: 24px;
  border: 2px solid #667eea;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: white;
}

.radio-circle {
  border-radius: 50%;
}

.checkbox-item input[type="checkbox"]:checked + .checkbox-label .checkbox-box,
.radio-item input[type="radio"]:checked + .radio-label .radio-circle {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: #667eea;
}

.checkbox-item
  input[type="checkbox"]:checked
  + .checkbox-label
  .checkbox-box::after {
  content: "✓";
  color: white;
  font-size: 16px;
  font-weight: bold;
}

.radio-item input[type="radio"]:checked + .radio-label .radio-circle::after {
  content: "";
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 50%;
}

.checkbox-item input[type="checkbox"]:checked + .checkbox-label,
.radio-item input[type="radio"]:checked + .radio-label {
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.1) 0%,
    rgba(118, 75, 162, 0.1) 100%
  );
  border-color: #667eea;
  font-weight: 600;
}

.checkbox-text,
.radio-text {
  flex: 1;
}

.form-actions-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 28px 32px;
  margin-top: 20px;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.submit-btn {
  padding: 16px 48px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-content {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.clear-btn {
  padding: 16px 32px;
  background: white;
  color: #667eea;
  border: 2px solid #667eea;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  display: flex;
  align-items: center;
  gap: 8px;
}

.success-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
}

.success-card {
  background: white;
  border-radius: 24px;
  padding: 48px;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.4);
  position: relative;
}

.success-icon-wrapper {
  margin-bottom: 32px;
  text-align: center;
}

.success-icon {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 50px;
  color: white;
  box-shadow: 0 16px 48px rgba(102, 126, 234, 0.4);
}

.success-title {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 12px 0;
  text-align: center;
  font-family: "Google Sans", Roboto, Arial, sans-serif;
}

.success-subtitle {
  font-size: 16px;
  color: #5f6368;
  margin: 0 0 32px 0;
  line-height: 1.6;
  text-align: center;
}

.success-details {
  background: linear-gradient(135deg, #f8f9fa 0%, #f0ebf8 100%);
  border-radius: 16px;
  padding: 24px;
  margin: 24px 0;
  border: 1px solid rgba(102, 126, 234, 0.1);
}

.detail-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(102, 126, 234, 0.1);
}

.detail-item:last-child {
  border-bottom: none;
}

.detail-icon {
  font-size: 24px;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  background: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);
}

.detail-text {
  font-size: 14px;
  color: #202124;
  line-height: 1.6;
  flex: 1;
  padding-top: 8px;
}

.success-note {
  font-size: 13px;
  color: #80868b;
  margin: 24px 0 0 0;
  text-align: center;
  font-style: italic;
}

.close-btn {
  width: 100%;
  padding: 16px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
  margin-top: 32px;
}

@media (max-width: 768px) {
  .event-form {
    padding: 85px 8px 40px;
  }

  .form-container {
    max-width: 100%;
    width: 95%;
    padding: 0 10px;
  }

  .form-header-card {
    padding: 28px 20px;
    border-radius: 16px;
  }

  .form-title {
    font-size: 26px;
    line-height: 1.3;
  }

  .form-subtitle {
    font-size: 14px;
    line-height: 1.5;
  }

  .form-card {
    padding: 22px 18px;
    border-radius: 16px;
    margin-bottom: 16px;
  }

  .form-label {
    font-size: 15px;
    margin-bottom: 10px;
  }

  .form-input {
    padding: 12px 14px;
    font-size: 14px;
  }

  .checkbox-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }

  .checkbox-label,
  .radio-label {
    padding: 12px 14px;
    font-size: 14px;
  }

  .form-actions-card {
    flex-direction: column;
    padding: 18px;
  }

  .submit-btn,
  .clear-btn {
    width: 100%;
    padding: 14px 24px;
  }

  .success-card {
    padding: 30px 22px;
    border-radius: 20px;
  }

  .success-icon {
    width: 80px;
    height: 80px;
    font-size: 40px;
  }

  .success-title {
    font-size: 24px;
  }

  .detail-item {
    flex-direction: column;
    gap: 12px;
  }

  .detail-icon {
    width: 36px;
    height: 36px;
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .event-form {
    padding: 80px 5px 35px;
  }

  .form-container {
    width: 98%;
    padding: 0 8px;
  }

  .form-header-card {
    padding: 24px 16px;
  }

  .form-title {
    font-size: 22px;
  }

  .form-subtitle {
    font-size: 13px;
  }

  .form-card {
    padding: 18px 14px;
    margin-bottom: 14px;
  }

  .form-label {
    font-size: 14px;
  }

  .form-input {
    padding: 11px 12px;
    font-size: 13px;
  }

  .checkbox-label,
  .radio-label {
    padding: 11px 12px;
    font-size: 13px;
  }

  .checkbox-box,
  .radio-circle {
    width: 20px;
    height: 20px;
  }

  .field-description {
    font-size: 12px;
  }
}
</style>
